import { Plus } from 'lucide-react';
import React from 'react'

function SectionHeader({ title, onAdd }: { title: string; onAdd?: () => void }) {
  return (
    <div className="mb-3 flex items-center justify-between px-1">
      <span className="text-xs font-semibold tracking-wider text-neutral-faded">{title}</span>
      {onAdd && (
        <button
          type="button"
          onClick={onAdd}
          className="flex items-center gap-1 text-emphasis text-[14px] font-medium text-violet-500 active:opacity-70"
        >
          <Plus size={14} strokeWidth={2.5} />
          Add
        </button>
      )}
    </div>
  )
}

export default SectionHeader